export const ConnectNowContactMethods = {
  Video: 'Video',
  WebChat: 'WebChat',
  SMS: 'SMS',
  Phone: 'Phone',
} as const;

export type ConnectNowContactMethod =
  (typeof ConnectNowContactMethods)[keyof typeof ConnectNowContactMethods];

export const ConnectNowAvailabilityStatuses = {
  Available: 'Available',
  Holiday: 'Holiday',
  AfterHours: 'AfterHours',
} as const;

export type ConnectNowAvailabilityStatus =
  (typeof ConnectNowAvailabilityStatuses)[keyof typeof ConnectNowAvailabilityStatuses];

export type OfflineStatus = Exclude<
  ConnectNowAvailabilityStatus,
  typeof ConnectNowAvailabilityStatuses.Available
>;

export type ContactMethodDefinition = {
  title: string;
  type: ConnectNowContactMethod;
  is247: boolean;
  availableElement: JSX.Element;
};
